import styles from "../../../moveout-checklist.module.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  bedroomfloorCovering: yup.string(),
  bedroomfloorCoveringOther: yup.string(),
  bedroomWallsCeiling: yup.string(),
  bedroomWallsCeilingOther: yup.string(),
  bedroomWindow: yup.string(),
  bedroomWindowOther: yup.string(),
  bedroomWindowConvering: yup.string(),
  bedroomWindowConveringOther: yup.string(),
  bedroomLightingFans: yup.string(),
  bedroomLightingFansOther: yup.string(),
  bedroomDoorHardware: yup.string(),
  bedroomDoorHardwareOther: yup.string(),
  bedroomHeating: yup.string(),
  bedroomHeatingOther: yup.string(),
  bedroomOutletsSwitches: yup.string(),
  bedroomOutletsSwitchesOther: yup.string(),
  bedroomSmokeAlarm: yup.string(),
  bedroomSmokeAlarmOther: yup.string(),
  bedroomOther: yup.string(),
  bedroomOtherOther: yup.string(),
});

const BedroomForm = ({
  onSubmitArrivalForm,
  tenantId,
  setLoading,
  moveOutCheckListInfo,
  handleChange4,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const bedroomValues = useWatch({
    control,
  });

  useEffect(() => {
    // setValue("bedroomfloorCovering", "new");
    // setTimeout(() => {
    //   setValue("bedroomWallsCeiling", "new");
    //   setv((p) => !p);
    // }, 2000);

    if (!moveOutCheckListInfo?.bedroom_data) return;

    const data = moveOutCheckListInfo.bedroom_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;

      const { value, is_other } = field;

      // Safely check that a value exists before setting
      if (is_other === 1 && value) {
        // setValue(key, "other");
        // setValue(`${key}Other`, value);
      } else if (is_other === 0 && value) {
        // setValue(key, value);
      }
      // else: don't call setValue at all
    });

    // Populate image state
    if (Array.isArray(moveOutCheckListInfo.bedroom_images)) {
      // setUploadedImages(moveOutCheckListInfo.bedroom_images);
    }
  }, [moveOutCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "bedroom_data";
    const formattedData = {
      bedroomfloorCovering: {
        value:
          data.bedroomfloorCovering === "other"
            ? data.bedroomfloorCoveringOther
            : data.bedroomfloorCovering,
        is_other: data.bedroomfloorCovering === "other" ? 1 : 0,
      },
      bedroomWallsCeiling: {
        value:
          data.bedroomWallsCeiling === "other"
            ? data.bedroomWallsCeilingOther
            : data.bedroomWallsCeiling,
        is_other: data.bedroomWallsCeiling === "other" ? 1 : 0,
      },
      bedroomWindow: {
        value:
          data.bedroomWindow === "other"
            ? data.bedroomWindowOther
            : data.bedroomWindow,
        is_other: data.bedroomWindow === "other" ? 1 : 0,
      },
      bedroomWindowConvering: {
        value:
          data.bedroomWindowConvering === "other"
            ? data.bedroomWindowConveringOther
            : data.bedroomWindowConvering,
        is_other: data.bedroomWindowConvering === "other" ? 1 : 0,
      },
      bedroomLightingFans: {
        value:
          data.bedroomLightingFans === "other"
            ? data.bedroomLightingFansOther
            : data.bedroomLightingFans,
        is_other: data.bedroomLightingFans === "other" ? 1 : 0,
      },
      bedroomDoorHardware: {
        value:
          data.bedroomDoorHardware === "other"
            ? data.bedroomDoorHardwareOther
            : data.bedroomDoorHardware,
        is_other: data.bedroomDoorHardware === "other" ? 1 : 0,
      },
      bedroomHeating: {
        value:
          data.bedroomHeating === "other"
            ? data.bedroomHeatingOther
            : data.bedroomHeating,
        is_other: data.bedroomHeating === "other" ? 1 : 0,
      },
      bedroomOutletsSwitches: {
        value:
          data.bedroomOutletsSwitches === "other"
            ? data.bedroomOutletsSwitchesOther
            : data.bedroomOutletsSwitches,
        is_other: data.bedroomOutletsSwitches === "other" ? 1 : 0,
      },
      bedroomSmokeAlarm: {
        value:
          data.bedroomSmokeAlarm === "other"
            ? data.bedroomSmokeAlarmOther
            : data.bedroomSmokeAlarm,
        is_other: data.bedroomSmokeAlarm === "other" ? 1 : 0,
      },
      bedroomOther: {
        value:
          data.bedroomOther === "other"
            ? data.bedroomOtherOther
            : data.bedroomOther,
        is_other: data.bedroomOther === "other" ? 1 : 0,
      },
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "bedroom_images";

    onSubmitArrivalForm(
      formattedData,
      sectionName,
      imageFiles,
      imageSectionName
    );

    // handleChange4("panel5")("event", true);
  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(
          process.env.REACT_APP_PAYMENT_API_URL +
          `v1/move-out-report-file-upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      console.error("Upload error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) =>
      prev.filter((img) => img.file_path !== fileNameToRemove)
    );
  };

  return (
    <div className={`${styles.FormSec}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>1. Floor and Floor Covering</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomfloorCovering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomfloorCovering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomfloorCoveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>2. Walls and Ceiling</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomWallsCeiling"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomWallsCeiling === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomWallsCeilingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>3. Window(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomWindow"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomWindow === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomWindowOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>4. Window Covering(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomWindowConvering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomWindowConvering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomWindowConveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>5. Lighting Fixture(s)/Fans</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomLightingFans"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomLightingFans === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomLightingFansOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>6. Door(s)/Hardware</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomDoorHardware"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomDoorHardware === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomDoorHardwareOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>7. Heating</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomHeating"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomHeating === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomHeatingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>8. Outlets/Switches</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomOutletsSwitches"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomOutletsSwitches === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomOutletsSwitchesOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>9. Smoke Alarms/CO Alarms</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="bedroomSmokeAlarm"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {bedroomValues?.bedroomSmokeAlarm === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomSmokeAlarmOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>10. Other</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <Controller
                  name="bedroomOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </FormControl>
            </div>
            {/* {bedroomValues?.bedroomOther === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="bedroomOtherOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )} */}
          </div>
        </div>

        {/* <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Floor and Floor Covering
            </InputLabel>
            <Controller
              name="bedroomfloorCovering"
              control={control}
              render={(field) => (
                <Select {...field} label="Floor and Floor Covering">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomfloorCovering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomfloorCoveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Walls and Ceiling
            </InputLabel>
            <Controller
              name="bedroomWallsCeiling"
              control={control}
              render={(field) => (
                <Select {...field} label="Walls and Ceiling">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomWallsCeiling === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomWallsCeilingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Window(s)</InputLabel>
            <Controller
              name="bedroomWindow"
              control={control}
              render={(field) => (
                <Select {...field} label="Window(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomWindow === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomWindowOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Window Covering(s)
            </InputLabel>
            <Controller
              name="bedroomWindowConvering"
              control={control}
              render={(field) => (
                <Select {...field} label="Window Covering(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomWindowConvering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomWindowConveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Lighting Fixture(s)/Fans
            </InputLabel>
            <Controller
              name="bedroomLightingFans"
              control={control}
              render={(field) => (
                <Select {...field} label="Lighting Fixture(s)/Fans">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomLightingFans === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomLightingFansOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Door(s)/Hardware
            </InputLabel>
            <Controller
              name="bedroomDoorHardware"
              control={control}
              render={(field) => (
                <Select {...field} label="Door(s)/Hardware">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomDoorHardware === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomDoorHardwareOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Heating</InputLabel>
            <Controller
              name="bedroomHeating"
              control={control}
              render={(field) => (
                <Select {...field} label="Heating">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomHeating === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomHeatingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Outlets/Switches
            </InputLabel>
            <Controller
              name="bedroomOutletsSwitches"
              control={control}
              render={(field) => (
                <Select {...field} label="Outlets/Switches">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomOutletsSwitches === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomOutletsSwitchesOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Smoke Alarms/CO Alarms
            </InputLabel>
            <Controller
              name="bedroomSmokeAlarm"
              control={control}
              render={(field) => (
                <Select {...field} label="Smoke Alarms/CO Alarms">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomSmokeAlarm === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomSmokeAlarmOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Other</InputLabel>
            <Controller
              name="bedroomOther"
              control={control}
              render={(field) => (
                <Select {...field} label="Other">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {bedroomValues?.bedroomOther === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="bedroomOtherOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div> */}

        <div className={`${styles.HalfSecFull}`}>
          <div className={`${styles.FileUpDuBUDiv}`}>
            <label
              htmlFor="file-upload-bedroom"
              className={`${styles.UploadLabel}`}
            >
              <span>
                <div className={`${styles.UpIcon}`}>
                  <img src="/static/img/upload-floor.svg" alt="" />
                </div>
                <p>Upload Pictures</p>
                <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
              </span>
            </label>
            <input
              id="file-upload-bedroom"
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </div>

          <div className={`${styles.UpIMGSec}`}>
            {uploadedImages.map((img, index) => (
              <div key={index} className={`${styles.ImgFile}`}>
                <img src={img.file_url} alt={img.file_path} />
                <Button
                  type="button"
                  onClick={() => removeImage(img.file_path)}
                >
                  <X />
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button
            className={`${styles.CancelPopupBU}`}
            onClick={handleChange4("panel4")}
          >
            Cancel
          </Button>
          <Button type="submit" className={`${styles.SubmitPopupBU}`}>
            Save & Continue
          </Button>
        </div>
      </form>
    </div>
  );
};

export default BedroomForm;
